export const getModeratorsItems = (state) => state.moderators.moderators
export const getIsLoadingModerators = (state) => state.moderators.isLoading
export const getModeratorsPagination = (state) => state.moderators.pagination